import PaginatedListView from "./PaginatedListView";

export default PaginatedListView;